module.exports = __WEBPACK_EXTERNAL_MODULE_123__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 123
// module chunks = 0